export default __webpack_public_path__ + "static/media/banner.4b2fb1b6.svg";